import baseUrlConfig from './apiConfig';

const getCurrentEnvironment = (): string => {
    const env = (import.meta.env.VITE_CURRENT_ENV || 'development').trim();
    return env.toLowerCase();
};

export const currentEnv = getCurrentEnvironment();

const currentConfig = baseUrlConfig[currentEnv] || baseUrlConfig.development;

if (!baseUrlConfig[currentEnv]) {
    console.error(
        `Configuration Error: No specific configuration found for environment "${currentEnv}". `,
        `Falling back to "${baseUrlConfig.development ? 'development' : 'MISSING DEVELOPMENT CONFIG'}" settings.`
    );
}

export const getApiBaseUrl = (): string => {
    if (!currentConfig?.apiGatewayBaseUrl) {
        console.error(`CRITICAL CONFIG ERROR: apiGatewayBaseUrl is not defined for environment "${currentEnv}" or the fallback.`)
        return '/api-config-error'; // Review system message retrieve with Bhaskar
    }
    return currentConfig.apiGatewayBaseUrl;
};
